import React, { memo } from 'react'
import { Box } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import Alerts from '../alerts'

const useStyles = makeStyles()(() => ({
    paper: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        height: '100%',
        minHeight: 0,
        width: '100%'
    }
}))

function AlertsSidebar() {
    const { classes } = useStyles()
    return (
        <Box className={classes.paper}>
            <Alerts />
        </Box>
    )
}

export default memo(AlertsSidebar)
